const _excluded = ["index"],
  _excluded2 = ["latitude", "longitude", "height"];
var _class;
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import i18next from "i18next";
import { action, makeObservable } from "mobx";
import loadCsv from "../../Core/loadCsv";
import loadJson5 from "../../Core/loadJson5";
import ItemSearchProvider from "./ItemSearchProvider";
import { IndexType, parseIndexRoot } from "./Index";
import joinUrl from "./joinUrl";
const t = i18next.t.bind(i18next);
/**
 * An ItemSearchProvider for searching an item using a pre-generated static index set.
 *
 */
let IndexedItemSearchProvider = (_class = class IndexedItemSearchProvider extends ItemSearchProvider {
  /**
   * Construct a IndexedItemSearchProvider.
   *
   * Throws an error if indexRootUrl option is not defined.
   *
   * @param options An object containing {indexRootUrl: string}
   */
  constructor(options, parameterOptions) {
    super(options, parameterOptions);
    _defineProperty(this, "indexRootUrl", void 0);
    _defineProperty(this, "indexRoot", void 0);
    _defineProperty(this, "resultsData", void 0);
    /**
     * Pre-emptively load the index while the user is entering input for the
     * parameter.
     */
    _defineProperty(this, "loadParameterHint", (parameterId, valueHint) => {
      const parameter = this.parameters.get(parameterId);
      if (parameter) {
        parameter.index.load(this.indexRootUrl, valueHint);
      }
    });
    makeObservable(this);
    const indexRootUrl = options === null || options === void 0 ? void 0 : options.indexRootUrl;
    if (typeof indexRootUrl !== "string") throw new Error(t("indexedItemSearchProvider.missingOptionIndexRootUrl"));
    this.indexRootUrl = indexRootUrl;
  }

  /**
   * Returns a Map of searchable parameters indexed by the parameter id.
   */
  get parameters() {
    var _this$indexRoot;
    const indexes = (_this$indexRoot = this.indexRoot) === null || _this$indexRoot === void 0 ? void 0 : _this$indexRoot.indexes;
    if (!indexes) return new Map();
    return new Map(Object.entries(indexes).map(_ref => {
      let [propertyId, index] = _ref;
      return [propertyId, _objectSpread(_objectSpread({}, this.buildParameterForIndex(propertyId, index)), {}, {
        index
      })];
    }));
  }

  /**
   * Returns a parameter object for the specified property.
   *
   * @param propertyId ID of the property
   * @param index The index definition of the property
   * @return The parameter object
   */
  buildParameterForIndex(propertyId, index) {
    var _parameterOptions$nam, _parameterOptions$nam2, _parameterOptions$nam3;
    const parameterOptions = this.parameterOptions.find(_ref2 => {
      let {
        id
      } = _ref2;
      return id === propertyId;
    });
    switch (index.type) {
      case IndexType.numeric:
        return {
          type: "numeric",
          id: propertyId,
          name: (_parameterOptions$nam = parameterOptions === null || parameterOptions === void 0 ? void 0 : parameterOptions.name) !== null && _parameterOptions$nam !== void 0 ? _parameterOptions$nam : propertyId,
          range: index.range
        };
      case IndexType.enum:
        return {
          type: "enum",
          id: propertyId,
          name: (_parameterOptions$nam2 = parameterOptions === null || parameterOptions === void 0 ? void 0 : parameterOptions.name) !== null && _parameterOptions$nam2 !== void 0 ? _parameterOptions$nam2 : propertyId,
          values: Object.entries(index.values).map(_ref3 => {
            let [id, {
              count
            }] = _ref3;
            return {
              id,
              count
            };
          })
        };
      case IndexType.text:
        return {
          type: "text",
          id: propertyId,
          name: (_parameterOptions$nam3 = parameterOptions === null || parameterOptions === void 0 ? void 0 : parameterOptions.name) !== null && _parameterOptions$nam3 !== void 0 ? _parameterOptions$nam3 : propertyId,
          queryOptions: parameterOptions === null || parameterOptions === void 0 ? void 0 : parameterOptions.queryOptions
        };
    }
  }

  /**
   * Fetches & parses the indexRoot file and then triggers fetching of the data
   * file but does not wait for it to complete.
   */
  async initialize() {
    const indexRootUrl = this.indexRootUrl;
    const json = await loadJson5(indexRootUrl);
    try {
      this.indexRoot = parseIndexRoot(json);
      this.getOrLoadResultsData();
    } catch (parseError) {
      console.warn(parseError);
      throw new Error(t("indexedItemSearchProvider.errorParsingIndexRoot", {
        indexRootUrl
      }));
    }
  }
  getIdPropertyName() {
    var _this$indexRoot2;
    const idPropertyName = (_this$indexRoot2 = this.indexRoot) === null || _this$indexRoot2 === void 0 ? void 0 : _this$indexRoot2.idProperty;
    if (!idPropertyName) throw new Error("indexRoot is not loaded");
    return idPropertyName;
  }

  /**
   * @returns A promise that resolves the search parameters.
   */
  async describeParameters() {
    return [...this.parameters.values()].map(_ref4 => {
      let {
          index
        } = _ref4,
        rest = _objectWithoutProperties(_ref4, _excluded);
      return rest;
    });
  }
  /**
   * Search the indexes for all the given parameter values and return the results.
   *
   * @param parameterValues A Map from parameterId to a search query
   * @returns A promise that resolves to the search results.
   */
  async search(parameterValues) {
    // This is roughly what happens in this function
    // 1) For each parameter search the corresponding index
    // 2) This gives a set of matching IDs
    // 3) Lookup the data corresponding to each matching ID from resultsData
    // 4) Use the data to build the search results.

    // Iterate each parameter and search its index.
    const search = Promise.all(Array.from(parameterValues).map(async _ref5 => {
      let [parameterId, value] = _ref5;
      const parameter = this.parameters.get(parameterId);
      if (!parameter) throw new Error("Unexpected parameter ".concat(parameterId));
      const ids = await this.searchParameter(parameter, value);
      return ids;
    }));

    // Meanwhile, load resultsData
    const data = await this.getOrLoadResultsData();

    // Merge the IDs from the search into a single set
    const idSets = await search;
    const matchingIds = intersectSets(idSets);

    // Map the IDs to data and build the search result.
    const results = [...matchingIds].map(id => this.buildResult(this.lookupDataForId(data, id), id));
    return results;
  }
  searchParameter(parameter, value) {
    const index = parameter.index;
    return index.load(this.indexRootUrl, value).then(() => index.search(value, parameter.queryOptions));
  }

  /**
   * Fetch resultsData URL and return it.
   *
   * Caches the data so that subsequent calls do not result in a network request & parsing.
   *
   * @return A promise that resolves to resultsData
   */
  async getOrLoadResultsData() {
    var _this$indexRoot3;
    if (this.resultsData) {
      return this.resultsData;
    }
    if (!((_this$indexRoot3 = this.indexRoot) !== null && _this$indexRoot3 !== void 0 && _this$indexRoot3.resultsDataUrl)) {
      throw new Error("indexRoot is not loaded");
    }
    const resultsDataUrl = joinUrl(this.indexRootUrl, this.indexRoot.resultsDataUrl);
    const promise = loadCsv(resultsDataUrl, {
      dynamicTyping: true,
      header: true
    });
    this.resultsData = promise;
    return promise;
  }
  lookupDataForId(rows, id) {
    const row = rows[id];
    if (!row) throw new Error("No data record found for item id: ".concat(id));
    return row;
  }

  /**
   * Build search result from raw data.
   *
   * @param record The resultData for the result item
   * @param dataIdx The index of the record in resultsData
   */
  buildResult(record, dataIdx) {
    if (!this.indexRoot) throw new Error("indexRoot is not loaded");
    const id = record[this.indexRoot.idProperty];
    if (id === undefined) {
      throw new Error("ID property not defined for data record at index ".concat(dataIdx));
    }

    // The record can have a bunch of arbitrary properties and a few known
    // properties. We use the latitude, longitude, height & radius for
    // constructing a zoom target for the search result.
    const {
        latitude,
        longitude,
        height
      } = record,
      properties = _objectWithoutProperties(record, _excluded2);
    const _latitude = parseFloat(latitude);
    const _longitude = parseFloat(longitude);
    const _featureHeight = parseFloat(height);
    if (isNaN(_latitude) || isNaN(_longitude) || isNaN(_featureHeight)) {
      throw new Error("No valid zoom point defined for data record at index ".concat(dataIdx));
    }
    const featureCoordinate = {
      latitudeDegrees: _latitude,
      longitudeDegrees: _longitude,
      featureHeight: _featureHeight
    };
    return {
      id,
      idPropertyName: this.indexRoot.idProperty,
      featureCoordinate,
      properties
    };
  }
}, _applyDecoratedDescriptor(_class.prototype, "buildParameterForIndex", [action], Object.getOwnPropertyDescriptor(_class.prototype, "buildParameterForIndex"), _class.prototype), _class);
export { IndexedItemSearchProvider as default };
export function intersectSets(sets) {
  if (sets.length === 0) return new Set();
  return sets.sort((a, b) => a.size - b.size).reduce((a, b) => new Set([...a].filter(x => b.has(x))));
}